import { auth as authAdmin } from "@/middlewares/admin";

export default {
  path: "resource-access-conditions",
  name: "EdicAdminFacilityResourceAccessConditionManage",
  component: () =>
    import(
      /* webpackChunkName: "edic-admin-facility-management-master-resource-access-condition-layout-view" */ "@/views/EdicAdmin/Facilities/Manage/ResourceAccessCondition/LayoutView"
    ),
  redirect: { name: "EdicAdminFacilityResourceAccessConditionSearch" },
  children: [
    {
      path: "", // /admin/resource-access-conditions
      name: "EdicAdminFacilityResourceAccessConditionSearch",
      component: () =>
        import(
          /* webpackChunkName: "edic-admin-facility-management-master-resource-access-condition-searching-view" */ "@/views/EdicAdmin/Facilities/Manage/ResourceAccessCondition/Search.vue"
        ),
      meta: {
        middleware: [authAdmin],
      },
    },
    {
      path: "create", // /admin/resource-access-conditions/create
      name: "EdicAdminFacilityResourceAccessConditionCreate",
      component: () =>
        import(
          /* webpackChunkName: "edic-admin-facility-management-master-resource-access-condition-create-view" */ "@/views/EdicAdmin/Facilities/Manage/ResourceAccessCondition/Create.vue"
        ),
      meta: {
        middleware: [authAdmin],
      },
    },
    {
      path: "edit/:id", //  /admin/resource-access-conditions/edit/1
      name: "EdicAdminFacilityResourceAccessConditionEdit",
      component: () =>
        import(
          /* webpackChunkName: "edic-admin-facility-management-master-resource-access-condition-edit-view" */ "@/views/EdicAdmin/Facilities/Manage/ResourceAccessCondition/Edit.vue"
        ),
      meta: {
        middleware: [authAdmin],
      },
    },
  ],
};
